import { pipe } from 'fp-ts/function'
import { mapValues, mapValuesC } from '@unimpaired/utils'
import * as R from 'ramda'
import React from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { twMerge } from 'tailwind-merge'

type AnimateVisibleProps = {
  visible: boolean
  children: React.ReactNode
  fade?: boolean
  /** This will add a <div /> around the children, this className is for that div */
  className?: string
}
export const AnimateVisible = (props: AnimateVisibleProps) => {
  const omitOpacity = props.fade ? R.identity : R.omit(['opacity'])

  const animation = pipe(
    {
      initial: { opacity: 0, height: 0 },
      animate: { opacity: 1, height: 'auto' },
      exit: { opacity: 0, height: 0 },
    },
    mapValuesC(omitOpacity),
  )

  return (
    <AnimatePresence>
      {props.visible && (
        <motion.div
          {...animation}
          className={twMerge('overflow-hidden', props.className)}>
          {props.children}
        </motion.div>
      )}
    </AnimatePresence>
  )
}
